function isPasswordResetRequirement(requirement) {
    return requirement.field === "reset_password" && requirement.hasOwnProperty("resetToken");
}
export function getPasswordResetRequirement(user) {
    var _a;
    return ((_a = user.missingRequirements) === null || _a === void 0 ? void 0 : _a.find(isPasswordResetRequirement)) || null;
}
